
import { EventManager } from '../services/event-manager.service';

export class MapService {

	mapOptions: google.maps.MapOptions;
	userOptions: google.maps.MapOptions;

	private eventManager: EventManager;
	private map: google.maps.Map;
	private mapUrl: string;
	private APIKey: string;

	constructor() {

		this.eventManager = EventManager.Instance;
		this.APIKey = 'AIzaSyAwICZ8NQiSHrEeYuhK1E4phHg531s7IcQ';
		this.mapUrl = `https://maps.googleapis.com/maps/api/js?key=${this.APIKey}`;

		this.eventManager.register('componentsLoaded', null, this.init);

	}

	init() {

		if (!document.querySelectorAll(`[src="${this.mapUrl}"]`).length) {

			document.body.appendChild(Object.assign(

				document.createElement('script'), {
					type: 'text/javascript',
					src: this.mapUrl,
					onload: () => this.broadcastEvent()
				}

			));

		}

	}

	private broadcastEvent() {
		this.eventManager.emit('googleMapsReady');
	}

}



// WEBPACK FOOTER //
// ./services/map.service.ts